// extracted by mini-css-extract-plugin
module.exports = {"container":"AddFilesBtn_container__OdQV9","button":"AddFilesBtn_button__3Faiv","buttonMedium":"AddFilesBtn_buttonMedium__pv-FN","tip":"AddFilesBtn_tip__3tLWE"};